import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel = "确定",
  cancelLabel = "取消",
  confirmColor = "error",
  loading = false,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog
      open={Boolean(open)}
      onClose={loading ? undefined : onCancel}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 0.5,
        },
      }}
    >
      {title && (
        <DialogTitle sx={{ fontWeight: 800, pb: 1 }}>{title}</DialogTitle>
      )}
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={onCancel}
          disabled={loading}
          sx={{ textTransform: "none" }}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color={confirmColor}
          onClick={onConfirm}
          disabled={loading}
          sx={{ textTransform: "none", fontWeight: 700, borderRadius: 2 }}
        >
          {loading ? "处理中..." : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
